<template>
  <div>
    <v-chart :options="opt" :autoresize="true" />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    prop: String,
    data: Array,
    colors: Array
  },
  data() {
    const textColor = '#fff';
    const axisColor = '#3da4a2';
    const lineColor = '#3da4a2';
    return {
      option: {
        color: this.colors,
        title: {
          left: 'center',
          top: 10,
          text: this.title,
          textStyle: {
            color: textColor,
            fontSize: 24
          }
        },
        legend: {
          show: false,
          right: 5,
          inactiveColor: '#ccc',
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          containLabel: true,
          left: 30,
          right: 30,
          bottom: 20
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            return `${params[0].axisValueLabel} <br/> ${params[0].marker} ${this.title}: ${
              params[0].value[this.prop]
            }`;
          }
        },
        dataZoom: [{ type: 'inside' }],
        xAxis: {
          type: 'time',
          axisLine: {
            lineStyle: {
              color: axisColor
            }
          },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: lineColor
            }
          },
          splitLine: { show: false }
        },
        series: [{ type: 'line', showSymbol: false }]
      }
    };
  },
  computed: {
    opt() {
      return {
        ...this.option,
        dataset: { source: this.data, dimensions: ['beginTime', this.prop] }
      };
    }
  },
  methods: {}
};
</script>

<style lang="scss"></style>
